"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Formats a price value with currency.
 * //Adds currency, comma, decimals
 * Adds only currency to the passed value
 * Since product does not want comma for 1st phase
 * eg. 149.50 SAR, // 1,23,456.33 SAR
 * Will be mainly used by all price values
 * @param {string} value
 * @param {string} currency
 * @returns {string}
 */
function formatPriceValue(value, currency) {
    return `${value} ${currency}`;
}
exports.default = formatPriceValue;
